import { Route } from "react-router-dom";
import AuthorizedRoute from "../../components/routing/authorized-route";
import { Features, Roles } from "../../components/routing/utils";

import Maris from "./page.highorder";

const ProtectedMarisComponent = () => {
  return (
    <AuthorizedRoute
      requiredRoles={[Roles.ADMIN]}
      component={Maris}
      requiredFeatures={[Features.MANAGE_MARIS]}
    />
  );
};

const marisRoute = (
  <Route path="/manage-maris" element={<ProtectedMarisComponent />} />
);

export default marisRoute;
